function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLongArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  fill: "none",
  viewBox: "0 0 124 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M123.061 13.06a1.502 1.502 0 0 0 0-2.12l-9.546-9.547a1.5 1.5 0 0 0-2.122 2.122L119.879 12l-8.486 8.485a1.501 1.501 0 0 0 2.122 2.122l9.546-9.546ZM0 13.5h122v-3H0v3Z",
  style: {
    fill: "currentColor",
    fillRule: "nonzero"
  }
}));
export default SvgLongArrow;